import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setSelectModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class SelectModalListItem extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    this.props.Callback(this.props.ItemId, this.props.Description);
  }

  render() {
    return (
        <button className="selectModalListItem" onClick={this.handleTouchTap}>
        {this.props.Description}
        <Ink />
        </button>
    )
  }
}

SelectModalListItem.propTypes = {
  Description: PropTypes.string.isRequired,
  ItemId: PropTypes.number.isRequired,
  setSelectModal: PropTypes.func.isRequired,
  Callback: PropTypes.func
}
function mapStateToProps() {
  return {
  }
}

export default connect(mapStateToProps, { setSelectModal })(SelectModalListItem)



// WEBPACK FOOTER //
// src/components/SelectModalListItem.jsx